var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessModelIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965",
    transform: "translate(1340 18570)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    transform: "translate(-1340 -18570)",
    fill: "#18beb3",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4963",
    "data-name": "Group 4963",
    transform: "translate(-103.215 -77.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5696",
    "data-name": "Path 5696",
    d: "M21,3.77H.429A.429.429,0,0,0,0,4.2V17.447a.429.429,0,0,0,.429.429H7.15l-2.3,3.764a.429.429,0,1,0,.732.446l2.568-4.211h2.133v5.28a.429.429,0,0,0,.857,0v-5.28h2.133l2.567,4.211a.429.429,0,1,0,.732-.446l-2.3-3.764H21a.429.429,0,0,0,.429-.429V4.2A.429.429,0,0,0,21,3.77Zm-.429,13.249H.857V4.627H20.573Z",
    transform: "translate(-1226.285 -18482.77)",
    fill: "#18beb3",
    stroke: "#18beb3",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M21.007,21.455a1.257,1.257,0,0,0,.336-2.468V17.509h6.982v1.479a1.257,1.257,0,1,0,.672,0V17.173h0a.336.336,0,0,0-.336-.336H25.171V15.775a1.717,1.717,0,1,0-.672,0v1.062H21.007a.336.336,0,0,0-.336.336v1.815a1.256,1.256,0,0,0,.336,2.467Zm2.782-7.364a1.045,1.045,0,1,1,1.045,1.045A1.046,1.046,0,0,1,23.789,14.091ZM29.246,20.2a.585.585,0,1,1-.585-.585A.586.586,0,0,1,29.246,20.2Zm-8.239-.585a.585.585,0,1,1-.585.585A.586.586,0,0,1,21.007,19.613Z",
    transform: "translate(-1240.035 -18488.873)",
    fill: "#18beb3",
    stroke: "#18beb3",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessModelIcon);
export default __webpack_public_path__ + "static/media/business-model-icon.9930ea4084514e564d0c6a21727037d7.svg";
export { ForwardRef as ReactComponent };